(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[8573],{

/***/ 46005:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var _services_analyticsUtag__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(69152);
/* harmony import */ var _errorPage_module_scss__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(34289);
/* harmony import */ var _errorPage_module_scss__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(_errorPage_module_scss__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(11163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(85893);








var ErrorPage = function ErrorPage(_ref) {
  var statusCode = _ref.statusCode,
      _ref$message = _ref.message,
      message = _ref$message === void 0 ? "This page could not be found." : _ref$message;
  var router = (0,next_router__WEBPACK_IMPORTED_MODULE_2__.useRouter)();
  (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function () {
    _services_analyticsUtag__WEBPACK_IMPORTED_MODULE_1__/* .view */ .ei({
      page_name: "".concat(statusCode, " error"),
      page_form_event: "error",
      page_errors: "".concat(statusCode, ". ").concat(message),
      page_error_type: "page",
      page_channel: "shopping"
    });
  }, []);
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.Fragment, {
    children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)("div", {
      className: (_errorPage_module_scss__WEBPACK_IMPORTED_MODULE_4___default().error),
      children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsxs)("div", {
        children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)("h1", {
          className: (_errorPage_module_scss__WEBPACK_IMPORTED_MODULE_4___default().code),
          children: statusCode
        }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)("div", {
          className: (_errorPage_module_scss__WEBPACK_IMPORTED_MODULE_4___default().wrapper),
          children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)("h2", {
            className: (_errorPage_module_scss__WEBPACK_IMPORTED_MODULE_4___default().message),
            children: message
          })
        })]
      })
    })
  });
};

/* harmony default export */ __webpack_exports__["Z"] = (ErrorPage);

/***/ }),

/***/ 50746:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": function() { return /* binding */ Custom500; }
/* harmony export */ });
/* harmony import */ var _components_molecules_errorPage_errorPage__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(46005);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(85893);


function Custom500() {
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_components_molecules_errorPage_errorPage__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z, {
    statusCode: 500,
    message: "Internal server error."
  });
}

/***/ }),

/***/ 65954:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/500",
      function () {
        return __webpack_require__(50746);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 34289:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"error":"errorPage_error__IZm6B","code":"errorPage_code__8Cazo","wrapper":"errorPage_wrapper__27LZ3","message":"errorPage_message__eTWen"};

/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [9774,2888,179], function() { return __webpack_exec__(65954); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);